import { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { AssessmentContext } from 'state/providers/AssessmentProvider';

const t = (key: string, options?) => translate('ui', key, options);

const CurriculumSelector = () => {
  const { availableCurriculums, isLoading, curriculumId, changeCurriculumId } =
    useContext(AssessmentContext);

  const [selectedCurriculumId, setSelectedCurriculumId] = useState('');

  // Works for now, but surely this isn't the right way to do this (local state for select mirroring AssessmentContext value)
  useEffect(() => {
    if (!selectedCurriculumId && curriculumId) setSelectedCurriculumId(curriculumId.toString());
  }, [curriculumId, selectedCurriculumId, setSelectedCurriculumId]);

  const handleSelectionChange = (event: SelectChangeEvent) => {
    const newCurriculumId = event.target.value;
    if (newCurriculumId && newCurriculumId !== curriculumId?.toString()) {
      setSelectedCurriculumId(newCurriculumId);
      changeCurriculumId(+newCurriculumId);
    }
  };

  if (isLoading) return null;

  return (
    <Grid item xs={3}>
      <Typography variant="subtitle1">{t('class.curriculum')}</Typography>
      {availableCurriculums.length > 0 ? (
        <FormControl fullWidth>
          <Select
            value={selectedCurriculumId}
            onChange={handleSelectionChange}
            IconComponent={MoreVertIcon}
          >
            {availableCurriculums.map((curriculum) => (
              <MenuItem key={`curriculum-${curriculum.id}`} value={curriculum.id}>
                {curriculum.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <Typography variant="body1">{t('class.curriculumNone')}</Typography>
      )}
    </Grid>
  );
};

export default CurriculumSelector;
